import { render } from "./mainswiper.vue?vue&type=template&id=8c4a6f5c&scoped=true"
import script from "./mainswiper.vue?vue&type=script&lang=js"
export * from "./mainswiper.vue?vue&type=script&lang=js"

import "./mainswiper.vue?vue&type=style&index=0&id=8c4a6f5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4a6f5c"]])

export default __exports__